export default "__VITE_ASSET__CjIEoB2e__"